module.exports = __webpack_public_path__ + "img/char-edit.7cc16abd.gif";